import adsIcon from '~/assets/icons/ads.svg';
import newsIcon from '~/assets/icons/news_2.svg';
import { ImgIcon } from '~/components/ui/ImgIcon';
import { AppAdsCreate } from '../../components/AppAdsCreate';
import { AppAdsLive } from '../../components/AppAdsLive';
import { AppAdsMyAds } from '../../components/AppAdsMyAds';
import { AdsStages } from '../../models/Ads';
import {
	setActiveAdsState,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import {
	StyledIconWrapper,
	StyledMenu,
	StyledWrapper,
} from './PhoneAds.styled';

const PhoneAds = () => {
	const dispatch = useLayoutDispatch();
	const activeAdsState = useLayoutSelector((state) => state.ads.activeAdsState);

	return (
		<StyledWrapper>
			{activeAdsState === AdsStages.LIVE && <AppAdsLive />}
			{activeAdsState === AdsStages.CREATE && <AppAdsCreate />}
			{activeAdsState === AdsStages.MY_ADS && <AppAdsMyAds />}
			<StyledMenu $hidden={activeAdsState === AdsStages.CREATE}>
				<StyledIconWrapper
					$active={activeAdsState === AdsStages.LIVE}
					onClick={() => dispatch(setActiveAdsState(AdsStages.LIVE))}
				>
					<ImgIcon icon={newsIcon} width={20} height={20} />
				</StyledIconWrapper>
				<StyledIconWrapper
					$active={activeAdsState === AdsStages.MY_ADS}
					onClick={() => dispatch(setActiveAdsState(AdsStages.MY_ADS))}
				>
					<ImgIcon icon={adsIcon} width={20} height={20} />
				</StyledIconWrapper>
			</StyledMenu>
		</StyledWrapper>
	);
};

export { PhoneAds };
